import { get } from 'lodash'
import {email, required} from 'utils/validation'
import { ACTIVITY_CATEGORIES } from 'constants/enums'

export default function(values = {}) {
  const errors = {
    activitySection: required(get(values, 'activitySection')),
    activityCategory: {
      id: required(get(values, 'activityCategory.id')),
      parent: {
        id: required(get(values, 'activityCategory.parent.id'))
      }
    },
    email:  required(get(values, 'email')) || email(get(values, 'email')),
    firstName: required(get(values, 'firstName')),
    lastName: required(get(values, 'lastName'))
  }

  if (get(values, 'activityCategory.id') === ACTIVITY_CATEGORIES.other.id) {
    errors.otherName = required(get(values, 'otherName'))
  }

  return errors
}
